// Auto generated file, do not manually modify!
// com.hotpads.cometdtos.authzone.ZgAuthZone

export enum ZgAuthZone {
  HOTPADS = 'hotpads',
  TRULIA = 'trulia',
  ZILLOW = 'zillow',
  ZRM = 'zrm',
}

export const ZgAuthZone_values = [ZgAuthZone.HOTPADS, ZgAuthZone.TRULIA, ZgAuthZone.ZILLOW, ZgAuthZone.ZRM] as const;
